import React, { Component, Fragment } from 'react';
import { message, Popover } from 'antd';
import _ from 'lodash';
import $ from 'jquery';

import './styles.module.scss';
import { API_HOST, ENTERTAIN_LINK } from '../../configs/env';
import whttp from '../../libs/whttp';

const VC_CONFIG = _.get(window, 'VC_CONFIG', {});
const PLUGIN_ASSETS_URL = _.get(window, 'VC_CONFIG.PLUGIN_ASSETS_URL');

const stringToBr = (text) => {
  return _.map(_.split(text, '\n'), (line, idx) => (
    <Fragment key={idx}>
      {line}
      <br />
    </Fragment>
  ));
};

// 前端頁面
export default class CIBCServicePoint extends Component {
  formRef = React.createRef();
  state = {
    query: {},
    storeInfo: undefined,
    listInfo: {
      current: 1, //目前頁數
      page_size: 10, //一頁幾筆
      total: 1, //以此query條件，總共幾筆資料
      rows: [],
    },
    store: [],
    area: null,
    branch: [],
    loading: false,
    content: null,
  };

  componentDidMount() {
    const query = {
      page_size: 'all',
      iscibc: 1,
    };
    this.loadConfig();
    this.loadData(query);
    this.setState({
      query,
    });
  }

  fillData = () => {
    this.formRef.current.setFieldsValue({
      phone: '123456',
      name: 'KK',
      licence: ['壽險', '產險', '外幣'],
      area: '北區',
      store: '新店店',
      city: '台北市',
      email: 'test@gamil.xxx',
      desc: '123test',
    });
  };

  loadConfig = () => {
    this.setState({ isLoadingData: true });

    whttp.get(API_HOST + '/api/v1/system/configs', {}, (state, res) => {
      this.setState({ isLoadingData: false });
      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) {
        return this.setState({ message: '發生錯誤' });
      }

      if (code !== 200) {
        return this.setState({ message: reason });
      }

      this.setState({ options: data.options }, () => {
        this.refreshPicker();
      });
    });
  };

  loadData = (query) => {
    this.setState({ isFetchData: true });

    whttp.sharedGet(API_HOST + `/api/v1/stores`, query, (state, res) => {
      this.setState({ isFetchData: false });

      const { code = 100, reason = '發生錯誤', data = {} } = res;

      console.log(code, reason, data, res);

      if (state === false || code !== 200) {
        message.warning(reason);
        this.props.history.replace('/cecservice');
        return;
      }

      this.setState({ listInfo: data });
    });
  };
  refreshPicker = _.debounce(() => {
    $('.selectpicker').selectpicker('refresh');
  }, 1000);

  loadCIBC = (id) => {
    this.setState({ isFetchData: true });
    whttp.get(API_HOST + `/api/v1/cibcs/${id}`, null, (state, res) => {
      this.setState({ isFetchData: false });

      const { code = 100, reason = '發生錯誤', data = {} } = res;

      console.log(code, reason, data, res);

      if (state === false || code !== 200) {
        message.warning(reason);
        return;
      }
      this.setState({ CIBCInfo: data });
    });
  };

  render() {
    const storeInfo = _.get(this, 'state.listInfo.rows', {});
    const options = _.get(this, 'state.options', {});
    const query = _.get(this, 'state.query', {});
    var branchCity = new Set();
    storeInfo.forEach((item) => {
      if (item.city_name) {
        if (!branchCity.has(item.city_name)) {
          branchCity.add(item.city_name);
        }
      }
    });
    this.refreshPicker();
    const CIBCInfo = _.get(this, 'state.CIBCInfo');
    //console.log("CIBCInfo",CIBCInfo)
    var content = <p>無</p>;
    if (_.get(this, 'state.CIBCInfo.users.length') > 0) {
      const CIBCInfo_users = _.get(this, 'state.CIBCInfo.users')[0];
      //console.log("CIBCInfo_users",CIBCInfo_users)
      content = (
        <div>
          {/* <img class="img-cover" style={{ height: 270, width:200 }} src={CIBCInfo_users&&CIBCInfo_users.image[0].url}/> */}
          <div class='card-cibcMan'>
            <img
              class='img-1-2 mb-3'
              style={{ height: 270, width: 200 }}
              src={CIBCInfo_users && CIBCInfo_users.image[0].url}
              alt=''
            />
            <p class='p text-primary my-2'>
              服務人員：{CIBCInfo_users && CIBCInfo_users.name}
            </p>
            <p class='p text-primary my-2'>
              服務年資：{CIBCInfo_users && CIBCInfo_users.seniority}年
            </p>
            <p class='p text-primary my-2'>
              駐點時間：
              {CIBCInfo_users &&
                `${CIBCInfo_users.open_at} - ${CIBCInfo_users.close_at}`}
            </p>
            <p class='p text-primary my-2'>
              持有證照：{CIBCInfo_users && CIBCInfo_users.licenses}
            </p>
          </div>
        </div>
      );
    }

    return (
      <main class='bg-light'>
        <div class='container'>
          <div class='breadcrumb-wrap py-4 m-0'>
            <nav aria-label='breadcrumb'>
              <ol class='breadcrumb'>
                <li class='breadcrumb-item'>
                  <a href={`${VC_CONFIG.INDEX_URL}`}>首頁</a>
                </li>
                <li class='breadcrumb-item'>
                  <a href={`${VC_CONFIG.INDEX_URL}`}>康達盛通保險經紀人 </a>
                </li>
                <li class='breadcrumb-item active' aria-current='page'>
                  服務據點
                </li>
              </ol>
            </nav>
          </div>
          <section class='pt-5 pb-0'>
            <div class='basic-tabs-border mb-5'>
              <ul class='nav nav-pills' id='pills-tab'>
                <li class='nav-item'>
                  <a class='nav-link' href={`${VC_CONFIG.INDEX_URL}/cibc`}>
                    首頁
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-about`}
                  >
                    康達盛通保險經紀人
                  </a>
                </li>
                <li class='nav-item'>
                  <a class='nav-link' href={ENTERTAIN_LINK}>
                    公平待客
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-service`}
                  >
                    服務項目
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-partner`}
                  >
                    合作夥伴
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-activity`}
                  >
                    活動剪影
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link active'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-servicepoint`}
                  >
                    服務據點
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-recruit`}
                  >
                    人才招募
                  </a>
                </li>
              </ul>
            </div>
          </section>
          <img
            class='img-cover'
            src={`${
              VC_CONFIG.INDEX_URL
            }/wp-content/themes/cec/assets/img/cibc/servicePoint/cibc_banner.png`}
            alt=''
          />
          <section>
            <h4 class='heading-title align-items-center'>
              請點選地圖上的區域，查看各地分店
            </h4>
            <hr class='border-top border-gray mt-0 mb-4' />
            <div class='row'>
              <div class='col-lg-3'>
                <svg
                  version='1.1'
                  id='map-SVG'
                  xmlns='http://www.w3.org/2000/svg'
                  xmlnsXlink='http://www.w3.org/1999/xlink'
                  x='0px'
                  y='0px'
                  viewBox={'0 0 500 950'}
                  style={{ enableBackground: 'new 0 0 500 950' }}
                  xmlSpace='preserve'
                >
                  <a href=' javascript:void(0)'>
                    <g
                      class='area active'
                      id='north'
                      data-toggle='tooltip'
                      data-placement='top'
                      title='北區'
                    >
                      <path d='M433.1,53.2l-0.3,11.3l0.2,2.9l3.5,3.7l-0.4,2.4l-2.4,1.7l-3.8,1.4l-4.9-0.6L415,71.8            l-2.9-2.1l-3.5-3.2l-2.7-3.3l-1.6-3.3l-2.8-3.5l-0.6-2.8l3-2.1l6.8-2.9l4.2-2.8l1.3,0.9l2.3,2.6l3.7,1.3L433.1,53.2L433.1,53.2z' />
                      <path d='M397.5,99l-4,1.6l-5.5-0.1l-4.6-1l-3.5-3.1l-3.6-4.1l-5.5-4.4l-3.7-6.4l1.4-7l-1.1-6l-5.4-5.2            l-3.6-4l1.5-2.8l1.7-2.3l2-4.4l3.4-3.8l10.4-6.1l2.8-2.4l3.8-1.9l3.6,1.1l2,2.1l-0.5,3.4l0.4,3.3l3,6.5l2.4,9.5l3.7,3.3l1.5,4.2            l-1.5,6.3l0.1,4.9l4.4,2.5l3.6,3l-1.9,4.1L397.5,99L397.5,99z' />
                      <path d='M232.9,171.1l-0.2,0.2l-4.4,1l-4.2-1.6l-2.6-3.6l-4.1-2.5l-6.6-2.6l1.1-3.9l5.2-10.8l2.1-2.9            l0.7-1.4v-1.6l-0.7-1.8l-1-2.1l1.4-2.9l1.7-1.7l7.9,3.4l14.4,4.6l5.1,2.7l3.6,3.7l1.8,3.5l-1,3.4l-2.3,1.3l-4.9,0.9l-5.6,2.3            l-3.2,4.1l-2.2,5.4L232.9,171.1z' />
                      <path d='M345.9,204l-2.2,6.2l-1.3,4.5l0.6,4.2l-3.6,5.5L326,237.9l-4.1,10l-2.7-0.8l-10.1,1l-0.8,0.6            l-0.6-4.7l-4.4-7.4l-3.1-3.1l-1.2-4.2l-4.8-3.8l-11.9,3l-4.6-0.5l-6.5,0.5l-7.3,2l-3.9-1l0.9-4.9l1.2-4.4l-1-3.8l-1-2.8l1-2.9            l0.8-3.3l0.3-3.7l-0.7-4.9l-3.7-3.2l-11.5-5.4l-5.7-4.3l-3.7-4.2l-4.2-10.6l2.3-2.9l2.2-5.3l3.2-4.1l5.6-2.3l4.9-0.9l2.3-1.3l1-3.4            l-1.8-3.5l-3.6-3.7l-5.1-2.7l-14.4-4.6l-7.9-3.4l1.4-2.2l0.6-3.7l0.9-2.8l1.9-2.8l2.6-2l2.4-0.9l-0.2-1.1l0.7-2.8l2.1-5.8l2-3.2            l2.9,1l13-1l4.4,2.9l3.8,8.3l4.8,1.9l4.1,1.1l3.9,1.9l6.5,2.1l3.4,4l-1,5.5l3.3,3.5l6.2,2l4,2.9l2.9,2.9l3.6,0.7l3.7-0.3l3.2,3.3            l2.5,4.3l4.1,2.1l3.2,2.5l0.4,4.8l1.5,6.9l-1.8,7.4L314,183l0.5,4.1l4.9,3.7l5.9,3.6l5.2,0.9l3.8,2.8l6.9,3.9L345.9,204L345.9,204z            ' />
                      <path d='M415.1,45.8l-4.2,2.8l-6.8,2.9l-3,2.1l0.6,2.8l2.8,3.5l1.6,3.3l2.7,3.3l3.5,3.2l2.9,2.1            l10.1,4.2l4.9,0.6l3.8-1.4l2.4-1.7l0.4-2.4l-3.5-3.7l-0.2-2.9l0.3-11.3l32.9,8l3,1.9l-1.5,3.5l-0.4,2.8l0.7,4.9l2.3,8.3l2.5,3.9            l2.1,0.9l6.7-1l3.4,0.4l4,1l3.5,1.8l1.9,2.4l-8.3,4.1l-0.8-1l-3.1-1.8l-5.6,1.2l-8,4.2l-3.5,2.4l-10.7,2.2l-1.3,2.8l2.4,3.4            l-1.5,3.6l-4.4,2.8l-3.3,1.1l-3.5,1.9l-3.1,3.9l-2.9,4.7l-4.8,3.4l-5.9,1.8l-12.8,7.7l-12.4,5l-3.6,2.2l-4.5,3.8l-1.9,4.7l0.2,4            l1,3l0.4,1.9l-3.7,2.7l-6.3,3l-4.8,3.3l-3.6,3.1l-4.7,1.7l-5.4,1.5l-2.4-5.1l-8.5-8.1l-1.3-5.3l-0.8-4.9l2.9-3.5l1.4-5l-8.1-11.7            l-4.8-1.9l-7,0.4l-4.9-2.8l1.2-6.4l-1-4.9l-5.1-4.9l-1-4.9l1-5.5l-0.2-5.9l3.5-3.8l12.5-3.7l3.1-3.2l1-4l-0.5-3.9l-4.9-7.1l-4-2.1            l-3.9-1l-3-2.7l-4.5-2.9l-6-2.8l-4-4.4l10.7-2l4.6-1.7l5.8-4.9l1.8-0.9l2.1-0.4h2.9l3.3,1l1.8,2.6l1.1,2.6l1.4,1.5l3.3-1.3            l-3.4-5.4l-5.5-5.6l-2.9-1.8l0.9-2.6l1.7-1.4l1.8-0.9l0.8-1l2-4.9l3-5.6l6.3-5.6l9.1-4.7l10.5-2.4l10.3,1.1l4.3,3.2l9.5,13.5l3.4,7            l1.1-0.5l2.6-0.7l2.9-0.4l2.1,0.6l-0.1,0.9l-1,1.2l-1,1.7l0.1,2.1l1,1.1L415.1,45.8L415.1,45.8z M397.5,99l7.2-9.1l1.9-4.1l-3.6-3            l-4.4-2.5l-0.1-4.9l1.5-6.3l-1.5-4.2l-3.7-3.3l-2.4-9.5l-3-6.5l-0.4-3.3l0.5-3.4l-2-2.1l-3.6-1.1l-3.8,1.9l-2.8,2.4L367,46.1            l-3.4,3.8l-2,4.4l-1.7,2.3l-1.5,2.9l3.6,4l5.4,5.2l1.1,6l-1.4,7l3.7,6.4l5.5,4.4l3.6,4.1l3.5,3.1l4.6,1l5.5,0.1L397.5,99L397.5,99z            ' />
                      <path d='M363.7,180.5l-2.9,0.9l-5.1,3.7l2.9,11.8l-2.1,3.6l-3.2,1.2l-3.1-0.6l-3.7,1.5l-0.5,1.4            l-4.6-2.1l-6.9-3.9l-3.8-2.8l-5.2-0.9l-5.9-3.6l-4.9-3.7L314,183l4.4-6.2l1.8-7.4l-1.5-6.9l-0.4-4.8l-3.2-2.5l-4.1-2.1l-2.5-4.3            l-3.2-3.3l-3.7,0.3l-3.6-0.7l-3-2.9l-4-2.9l-6.2-2l-3.3-3.5l1-5.5l-3.4-4l-6.5-2.1l-3.9-1.9l-4.1-1.1l-4.8-1.9l-3.8-8.3l-4.4-2.9            l-13,1l-2.9-1l8.5-13.5l6.6-7.9l6.8-5.8l17.5-5.8l4.1-2.6l3.5-3l4.3-2.4l8.6-3l19.1-3.4l4,4.4l6,2.9l4.5,2.9l3,2.7l3.9,1l4,2.1            l4.9,7.1l0.5,3.9l-1,4l-3.1,3.2l-12.5,3.7l-3.5,3.8l0.2,5.9l-1,5.5l1,4.9l5.1,4.9l1,4.9l-1.2,6.4l4.9,2.8l7-0.4l4.8,1.9l8.1,11.7            l-1.4,5l-2.9,3.5l0.8,4.9l1.3,5.3l8.5,8.1L363.7,180.5L363.7,180.5z' />
                      <path d='M433.7,278.2h-1l-10.6-1.6L404.5,266l-3.6,0.9l-2.3,5.7l-4.7,4.3h-6.2l-7.9-3l-14.3-3.6            l-6.2-2.9l-2.4-2l-5.6-4.5h-4.7l-4.5,2.2l-3.8,0.6l-3.5-2.4l-4.2-2.5l-4.7-1l-1.3-3.6l0.6-5.2l-3.4-1l4.1-10l13.3-13.5l3.6-5.5            l-0.6-4.2l1.3-4.5l2.2-6.2l0.5-1.4l3.7-1.5l3.1,0.6l3.2-1.2l2.1-3.6l-2.9-11.8l5.1-3.7l2.9-0.9l5.4-1.5l4.7-1.7l3.6-3.1l4.8-3.3            l6.3-3l3.7-2.7l-0.4-1.9l-1-3l-0.2-4l1.9-4.7l4.5-3.8l3.6-2.2l12.4-5l12.8-7.7l5.9-1.8l4.8-3.4l2.9-4.8l3.1-3.9l3.5-1.9l3.3-1.1            l4.4-2.8l1.5-3.6l-2.4-3.4l1.3-2.8l10.7-2.2l3.5-2.4l8-4.2l5.6-1.2l3.1,1.8l0.8,1l-11.4,5.7l-5.2,4.5l-17.8,21.7l-2.8,4.6l-2.2,6.5            l-1.5,7.3l-0.5,7.2l0.3,7l3.1,14.7l-0.2,3.8l-1.4,3.7l0.2,7.7l3.3,6l6.2,3.8l7.2,1.3v1.7l-3-0.3l-2.9,0.3l-2.5,0.8l-1.8,1.3            l2.6,4.8l1.2,6.2l-0.8,5.3l-5.7,3.2l-0.4,2.4l0.7,2.9l1.6,2.6l0.6,2.7l-2.4,2.3l-5.9,3.4l-6.7,7.6l-0.3,3l0.5,6.7l-1.1,2.5            l-1.2,2.2l-0.8,3l-0.5,6.1l-0.6,1.5l-1,1.2l-0.5,1.3L433.7,278.2z' />
                      <path d='M433.7,278.1l0.6,0.8l1.5,2.8l0.2,1l-1.3,2.3l-5.5,5.4l-5.9,8.2l-4.5,3.5l-1.3,1.9l0.7,2            l-0.9,1.4l-6.3,4.9l-2.4,2.3l-2.7,5.7l-2.8,11.6l-7,10.4l-1.4,4.2l0.2,4.5l1.7,4.9l1.4,2.2l1.2,1l0.8,1.3l0.1,3l-1,3.4l-3.5,5.5            l-0.7,3.3l-0.4,6.1l-3,15.5l-6.1,16.2l-7.6,38.1l-4.6,9.3l-10.5,61l-3.3-1l-10.3,4.9l-3.7,5.1l1.6,6.6l0.6,6.6l-3.4,6.6l-3.2,4.9            l-2.6,6.3l-2.3,8l-3.5,7.3l-4.6,12.6l-2.9,5.8l0.1,6.4l-0.9,5.9l-6.2,3.5l-7.8-1l-11.2-9.2l-8.8-15.2l-5.4-1.4l-6-0.9l-4.8-4.6            l-5.8-2.8l-7.4-2.7l-4.8-7.7l-1.1-7l-0.3-2.4l-2.7-7.2l-6-4.9l-5.3-3.4l-1-3.8l1.3-3l5.3-2.3l2.9-4.8l-1.8-5.5l5.7-3.3l2.9-2.7            l-1.6-5.9l1.4-2.6l1.4-3.8l4.9-3.7l7-1.5l7-0.3l5-4.5l1.2-8.1l3.8-4.9l7.2-2.7l4.3-2.9l1.5-4.9l3-12l1.1-8l-0.9-6.8l-1.1-5.1            l-3-3.9l-2-3.8l5.4-8.9l0.2-3.5l2.4-6.7l3.7-8.1l2.9-8.4l1.5-9.4l0.6-7.2l-1.7-4.3l-1.9-3.1l2.2-7.2l4.9-10.2l7.6-9.9l0.3-3.7            l-1.4-4.3l-4.9-3.2l-2.8-2.9l-0.2-9.4l3.5-2.8l6.3-2.1l4.9-2.3l-0.2-3.5l-1.3-5.9l2.7-1.9l1.1-2l3.2-1.6l2.9-3.6l1.2-4.9l2.9-4.8            l7.1-4.5l2.3-5.9l0.4-4l4.5-4.7l2.4,2l6.2,2.9l14.3,3.6l7.9,3h6.2l4.7-4.3l2.3-5.7l3.6-0.9l17.6,10.6l10.6,1.6L433.7,278.1z' />
                    </g>
                  </a>
                  <a href=' javascript:void(0)'>
                    <g
                      class='area'
                      id='south'
                      data-toggle='tooltip'
                      data-placement='bottom'
                      title='南區'
                    >
                      <path d='M247.6,521.5l1.8,5.5l-2.9,4.8l-5.3,2.3l-1.3,3l1,3.8l5.3,3.4l6,4.9l2.7,7.2l0.3,2.4            l-14.8,3.6l-6.1,3.9l-3.8,3.7l-7.4,4.9l-0.9,5.4l2.2,5.7l-2.6,4.7l-7,3.8l-0.8,6.6l2,9.4l-2.9,12.6l-0.1,10.7l-4.1,5.6l-8.1,6.8            l-2.2,9.3l1.2,7.7l2.9,4.4l5.9,6.1l1.1,4.7l-3.7,0.5l-4.9-0.9l-4.1,0.2l-8.1,6.4l-5.6-5.2l-7.2-8.5l-6.8,1.7l-6.3,5.6l-12.5-6.3            l-8.9,4.3l-6.1,6.8l-7.6,2.7l-16.9-1l-1.6,4.7l-1.2,6.8l-2.5,7.5l0.5,6.7l-0.1,9l-5.4,20.2l-0.1,6.8l2.6,7.1l0.4,7.8l-7.7,19.5            l-2.5-1l-1.5,0.1l-1.7,0.7h-2.1l-12.4-9.7L64,754.3L76.1,769l-1.4-7l-3.6-6.8l-5-5.7l-8.6-8l-3.3-4l-1.5-4.6l2.1-4.4l1-3.9            l-1.4-5.5l-2.6-5.3l-4.7-7.3l-4.4-9.7l-1-4.3l0.1-2.9l1.4-3.4l0.3-2.3l-0.5-1.1l-2.6-2.2l-0.5-2.2l-2.8-4.7l-0.7-1.9l-2-12.9            l5.8-3.5l0.2,0.5l3.7,8.2l4.6,2.4l14.9,2.1l7.8-0.9l8,1l4-1.4l3.3-2.5l6.2-2.5l6-4.2l2.3-5.2l2.9-4.9l5-6.8l5.8-6.1l6.2-5.1l7-6.8            l6.2-8l9.5-16.2l9.9-14.4l2.2-6.3l-1-6.4l-1.3-4.3l0.1-4.8l3.4-3.3l6.6,0.7l5.5-0.6l11.7-6.9l4.3-5.1l7.5-5.8l7.3-4.1l4-4.8            l3.4-6.5l8.1-6.5l17.6-8.9l4.1,1l5.5,2.1l4,5.6L247.6,521.5L247.6,521.5z' />
                      <path d='M206.1,678.8l3.3,6.3l0.7,4.7l5.1,1.2l5.2,3.4l-2.7,13.1l-0.1,4.9l-1.9,4.8l-9.3,3.9l-4.6,2.6            l-7.2,1.5l-5.1,4.3l-2.3,6.3l-3.5,6.3l-2.9,7.1l-0.8,14l1.1,6.2l1.9,5.8l1,6.8v5.1l2.5,4.8l4.4,5.3l-2.4,3.6l-5,3l-2,3.7l-0.5,4.3            l2.6,3.7l3.2,1.6l2.9,4.2l-0.1,5.4l0.6,5.8l3,5.6l4.4,4.7l9.7,4.5l4.3-0.3l0.9,49.1l-1.5,6.9l-2.4,5.7l-3.2,2.4l-3.8,3.5l0.1,7.9            l1.4,8.8l-0.4,5.6l-4.3-6.5l-6.5-4.9l-7.4-3.3l-7.6-1.8l-0.3,6.3l-2.2,2.2l-3.2-0.8l-3.5-2.9l-0.2-2.3l1.2-6.7l-5.2-8.8l-0.5-2.3            l0.1-2l0.4-3v-10.3l0.5-2.9l2.4-3.4l0.5-2.9L148,831.5l-1.5-2.8l-5.2-6.5l-4.2-9.4l-1.9-2.7l-7.8-6.2l-5.1-2.9l-0.9-3.5l-0.7-1.2            l-4.2-2.8L107,789l-4.3-2.9l-4.6-4l-2.5-1.5l7.7-19.5l-0.4-7.8l-2.6-7.1l0.1-6.8l5.4-20.2l0.1-9l-0.5-6.7l2.5-7.5l1.2-6.8l1.6-4.7            l16.9,1l7.6-2.7l6.1-6.8l8.9-4.3l12.5,6.3l6.3-5.6l6.8-1.7l7.2,8.5l5.6,5.2l8.1-6.4l4.1-0.2L206.1,678.8z' />
                      <path d='M156.1,578.2l-2.2,6.3l-9.9,14.4l-9.5,16.2l-6.2,8l-7,6.8l-6.2,5.1l-5.8,6.1l-5,6.8l-2.9,4.9            l-2.3,5.2l-6,4.2l-6.2,2.5l-3.3,2.5l-4,1.4l-8-1l-7.8,0.9l-14.9-2.1l-4.6-2.4l-3.7-8.2l-0.2-0.5l-5.8,3.5l-1-6l-1.7-3.4l-3.7-3.7            l4.5-3.2l2.6-5.8l-1-4.9l-6-0.9l-1.1,1.7l-1,3.2l-1.7,2.6l-3.1-0.1l-1.2-2.2l0.5-6.7l-0.8-2.3l-3.9-1.7l-2.2,2l-1.7,2.8l-2.7,0.7            l-2.8-2.4l-0.7-3.3l0.7-3.2l1-2.2l2.9-1.5l3.5-0.5l2.9-1l1-2.9l-1.3-1.4l-8.9-2.3v-1.8l7.5-0.1l-0.8-2.5l-4.1-3.5l-2.7-3l0.7-3.8            l2.4-1.4l2.6-0.9l1.3-2.4l-0.8-3.7l-1.3-3l0.9-2.9l1.3-3.5l2.2-2.5l-0.5-2.2l0.5-2.2l3.1-8.6l1.5-1.6l2.5-0.6l-3.5-2.4l1.5-3.9            l4.9,1.9l8.5,1.2l6.8,1.7l5.9-2.7l2.4-4.7l5.5-3.4l6.3-4.9l4.5-4.6l5.8-4.4l7.4-3.3l14.5-2.7l8.1-0.5l6.8,2.3l3.8,2.3l2,4l1.6,4.9            l9.4,9.6l0.9,7.1l-1.7,13.5l1.5,4.4l4.3,3.3h3.6l5-2.3l4.8-0.6l3.5,1L156.1,578.2z' />
                      <path d='M211.8,847l-4.3,0.3l-9.7-4.5l-4.4-4.7l-3-5.6l-0.6-5.8l0.1-5.4l-2.9-4.2l-3.2-1.6l-2.6-3.7            l0.5-4.3l2-3.7l5-3l2.4-3.6l-4.4-5.3l-2.5-4.8v-5.1l-1-6.8l-1.9-5.8l-1.1-6.2l0.8-14l2.9-7.1l3.5-6.3l2.3-6.3l5.1-4.3l7.2-1.5            l4.6-2.6l9.3-3.9l1.9-4.8l0.1-4.9l2.7-13.1l-5.2-3.4l-5.1-1.2l-0.7-4.7l-3.3-6.3l3.7-0.5l-1.1-4.7l-5.9-6.1l-2.9-4.4l-1.2-7.7            l2.2-9.3l8.1-6.8l4.1-5.6l0.1-10.7l2.9-12.6l-2-9.4l0.8-6.6l7-3.8l2.6-4.7l-2.2-5.7l0.9-5.4l7.4-4.9l3.8-3.7l6.1-3.9l14.8-3.6            l1.1,7l4.8,7.7l7.4,2.7l5.8,2.8l4.8,4.6l6,0.9l5.4,1.4l8.8,15.2l11.1,9.2l7.8,1l6.2-3.5l0.9-5.9l-0.1-6.4l2.9-5.8l4.6-12.6l3.5-7.3            l2.3-8l2.6-6.3l3.2-4.9l3.4-6.6l-0.6-6.6l-1.6-6.6l3.7-5.1l10.3-4.9l3.3,1l-4.4,25.1l-2.1,4.7l-6.8,8.9l-2.5,4.7l-2,5.8l-1.4,10.8            l0.2,9.7l-1,9.2l-4.7,9.4l-2,2l-4.5,3.3l-2.1,2.1l-1,2.2l-1.6,5.5l-4.6,8l-2.8,12.5l-2,5.6l-9.8,14.1l-1.2,2.6l-13.2,11.2l-3.1,3.6            l-0.4,2.6l0.6,5.9l-0.2,2.7l-1.1,3l-2.1,3.3l-4.5,5.8l-4.5,4.3l-15.3,10.2L252.6,732l-2.6,1.3l-2,2.6l-4.9,12.8l-2.5,4.8L233,763            l-3.1,5.7l-1.8,11.7l-4.6,16l-9,15.9l-1.3,5.4l-1.6,15.3L211.8,847z' />
                    </g>
                  </a>
                  <a href=' javascript:void(0)'>
                    <g
                      class='area'
                      id='west'
                      data-toggle='tooltip'
                      data-placement='right'
                      title='中區'
                    >
                      <path d='M159.5,361.9l0.1,3.4l-4.1,1.5l-1.1,2.8l0.5,3.8l-1.9,4.4l-1.5,5.1l-0.1,5.4l-1.1,6.3            l-0.9,12.7l2,6l3.4,3.1l3.7,1.3l5.3,2.8l-1,3.3l-3.6,1.4l-2.4,2.2l-2.3,1.5l-1,0.7l-11.4-2.3l-5.5,0.1l-11.6-5.7l-18.7-2.2l-11-4.2            l-6.3-1.7l-7.2-0.4l-20.9,2.5l-7.2-4.2l0.8-1.3l1.5-6.8l1.1-2.9l6.8-6.5l1.9-2.7l2.6-7.4l4-7.3l5.4-15.3l2.6-4.5l2.9-2.9l2.4-1.6            l2.1-1l1.5-1.3l0.6-2.9l1.1-2.7l4.9-3.8l1.1-2.9l0.6-9.6l0.9-2.7l2.6-2.5l10.7-12.6l5.5,1.8l3.8,3.3l2.6,6l1,7.2l4.3,5.1l11.3,3.3            l4.1,3.4l3,4.8l1.9,3.8l0.1,3.8l1.1,3.1l4.1,0.8l5.1,3.3L159.5,361.9L159.5,361.9z' />
                      <path d='M328.7,303l1.3,5.9l0.2,3.5l-4.9,2.3l-6.3,2.1l-3.5,2.8l0.2,9.4l2.8,2.9l4.9,3.2l1.4,4.3            l-0.3,3.7l-7.6,9.9l-4.9,10.2l-2.2,7.2l1.9,3.1l1.7,4.3l-0.6,7.2l-1.5,9.4l-2.9,8.4l-3.7,8.1l-2.4,6.7l-0.2,3.5l-5.4,8.9l2,3.8            l3,3.9l1.1,5.1l0.9,6.8l-1.1,8l-3,12l-1.5,4.9l-4.3,2.9l-7.2,2.7l-3.8,4.9l-1.2,8.1l-5,4.5l-7,0.3l-7,1.5l-4.9,3.7l-1.4,3.8            l-1.4,2.6l1.6,5.9l-2.9,2.7l-5.7,3.3l-0.7-1.9l-4-5.6l-5.5-2.1l-4.1-1l-0.9-0.2l-24.4-0.2l-7.2-1.3l-1-3.6l-0.4-5.6l-2.6-6.2            l-1.1-4.6l2.9-4.9l0.3-5l-4.9-2.7l-3.9-1.1l-6.5-2.5l-5.8-0.7l-2.5-3.3l-7.8,0.9l-6.5,1.9l-5.5-2.4l-3.8-4.5l0.9-5.4l1.8-4.9            l-1-7.3l1-6.8l1.9-4.5l-1.8-6.8l2.3-1.5l2.4-2.2l3.6-1.4l1-3.3l-5.3-2.8l-3.7-1.3l-3.4-3.1l-2-6l0.9-12.7l1.1-6.3l0.1-5.4l1.5-5.1            l1.9-4.4l-0.5-3.8l1.1-2.8l4.1-1.5l-0.1-3.4l4.1,0.2l17,2.4l4-0.6l4.8-4.6l7.2-13.7l3.5-8.1l6.1-2.9l9.6,1.3l5.7-0.2l5.5-7.3            l2.9-1.8l8.5,6.4l3.3-0.9l2.5-5.2l4.5-3.7l6.3,0.1l4.8-1.8l7.5-7.2l4.9-2.8l4.2-0.8l8.4-4.5l5.9-0.2l6-1l10.6-4.2l4.4-0.3l4.5,1            L328.7,303L328.7,303z' />
                      <path d='M308.4,248.7l0.8-0.6l10.1-1l2.7,0.8l3.4,1l-0.6,5.2l1.3,3.6l4.7,1l4.2,2.5l3.5,2.4l3.8-0.6            l4.5-2.2h4.7l5.6,4.5l-4.5,4.7l-0.4,4l-2.3,5.9l-7.1,4.5l-2.9,4.8l-1.2,4.9l-2.9,3.6l-3.2,1.6l-1.1,2l-2.7,1.9l-12.7-1.2l-4.5-1            l-4.4,0.3l-10.6,4.2l-6,1l-5.9,0.2l-8.4,4.5l-4.2,0.8l-4.9,2.8l-7.5,7.2l-4.8,1.8l-6.3-0.1l-4.5,3.7l-2.5,5.2l-3.3,0.9l-8.5-6.4            l-2.9,1.8l-5.5,7.3l-5.7,0.2l-9.6-1.3l-6.1,2.9l-3.5,8.1l-7.2,13.7l-4.8,4.6l-4,0.6l-17-2.4l-4.1-0.2v-1.3l-5.1-3.3l-4.1-0.8            l-1.1-3.1l-0.1-3.8l-1.9-3.8l-3-4.8l-4.1-3.4l-11.3-3.3l-4.3-5.1l-1-7.2l-2.6-6l-3.8-3.3l-5.5-1.8l0.6-0.8l0.8-3.1l3.1-2.6l2.1-6.2            l2.6-11.7l8.8-15.3l2.7-9.4l3.2-5.2l12.7-14.1l8.8,13.6l4.5,4.8l6,5.2l14.4,10.6l6.9,3.4l6.3,1.1l11,6.4l11.5-0.7l4.9-2.7l0.9-7            l5.2-3.1l9.4,0.8l5.7,2.3l4.8,5.3l5.1,2l8.5-4.5l6.5-2.8l11-8.8l5.6-3l4.4-4.2l4-2.9l5,0.1l4.7-1.9l1.7-5.3L308.4,248.7            L308.4,248.7z' />
                      <path d='M154.6,429.1l1.8,6.8l-1.9,4.5l-1,6.8l1,7.3l-1.8,4.9l-0.9,5.4l3.8,4.5l5.5,2.4l6.5-1.9            l7.8-0.9l2.5,3.3h-0.5l-0.3,4.8v3.2l-3.8,1.2l-11.1,2.3l-6,0.6l-2.3-3.7l-4.5-3.2l-7.9,2.3l-3.5,0.5l-12-4.4l-4.8-5.6l-5-4.4            l-6.6,0.4l-12,2.2l-6.8,1.9l-15.5,8.9l-3.6,3.6l-4.2,2.3l-6.7,5.4l-5,0.8l-2,2.9l-1.6,4.7l-3.7,3l-5.8-0.1l-7.9-4.5l-11,1.3            l4.4-4.9L28,478.2l0.7-11.7l2.7-9.3l4.1-7.3l1.2-9.5l2.2-8.4l1.2-2.9l5.8-7.7l1-2.7l0.7-1.4l5.3-4.1l0.8-1.5l7.2,4.2l20.9-2.5            l7.2,0.4l6.3,1.7l11,4.2l18.7,2.2l11.6,5.7l5.5-0.1l11.4,2.3L154.6,429.1L154.6,429.1z' />
                      <path d='M232.9,171.1l4.2,10.6l3.7,4.2l5.7,4.3l11.5,5.4l3.7,3.2l0.7,4.9l-0.3,3.7l-0.8,3.3l-1,2.9            l1,2.8l1,3.8l-1.2,4.4l-0.9,4.9l3.9,1l7.3-2l6.5-0.5l4.6,0.5l11.9-3l4.8,3.8l1.2,4.2l3.1,3.1l4.4,7.4l0.6,4.7l-3.5,2.5l-1.7,5.3            l-4.7,1.9l-5-0.1l-4,2.9l-4.4,4.2l-5.6,3l-11,8.8l-6.5,2.8l-8.5,4.5l-5.1-2l-4.8-5.3l-5.7-2.3l-9.4-0.8l-5.2,3.1l-0.9,7l-4.9,2.7            l-11.5,0.7l-11-6.4l-6.3-1.1l-6.9-3.4L167.3,266l-6-5.2l-4.5-4.8l-8.8-13.6l6.8-7.7l1.8-3.8l0.9-6.3l2.1-5.3l5.6-9.9l1.5-6l1.4-2.6            l6.5-1.9l1.8-2l1-2.5l1.3-2.4l4-4.1l4.4-3.2l5.3-1.4l6.8,1.2l-0.9-5.1l2.6-3.5l3.5-3.6l1.8-5.4l0.8-1.8l3.4-1.7l0.3-1.2l6.6,2.6            l4.1,2.5l2.6,3.6l4.2,1.6l4.4-1L232.9,171.1L232.9,171.1z' />
                      <path d='M177.9,472.4l5.8,0.7l6.5,2.5l3.9,1.1l4.9,2.7l-0.3,5l-2.9,4.9l1.1,4.6l2.6,6.2l0.4,5.6l1,3.6            l7.2,1.3l24.4,0.2l0.9,0.2l-17.6,8.9l-8.1,6.5l-3.4,6.5l-4,4.8l-7.3,4.1l-7.5,5.8l-4.3,5.1l-11.7,6.9l-5.5,0.6l-6.6-0.7l-3.4,3.3            l-0.1,4.8l1.3,4.3l1,6.4l-8-1l-3.5-1l-4.8,0.6l-5,2.3h-3.6l-4.3-3.3l-1.5-4.4l1.7-13.5l-1-7.1l-9.4-9.6l-1.6-4.9l-2-4l-3.8-2.3            l-6.8-2.3l-8.1,0.5l-14.5,2.7l-7.4,3.3l-5.8,4.4l-4.5,4.6l-6.3,4.9l-5.5,3.4l-2.4,4.7l-5.9,2.7l-6.8-1.7l-8.5-1.2l-4.9-1.9l3.6-0.3            l3.1-1.3l1.3,0.5l-0.9-3l-2.1,1.5l-1.7-0.5l-2.4-0.1v-3.1l2.3-5.3l3.5-0.3l5.1,0.1l-3.5-10l-3.9-7.6l1.8-3.5V519l-2.9-1.4l0.4-1.7            l1.7-1.9l0.9-2.5l3.8-4.9L24,507l-0.2-8.3l11-1.3l7.9,4.5l5.8,0.1l3.7-3l1.6-4.7l2-2.9l5-0.8l6.7-5.4l4.2-2.3l3.6-3.6l15.5-8.9            l6.8-1.9l12-2.2l6.6-0.4l5,4.4l4.8,5.6l12,4.4l3.5-0.5l7.9-2.3l4.5,3.2l2.3,3.7l6-0.6l11.1-2.3l3.8-1.2v-3.2l0.3-4.8L177.9,472.4z' />
                    </g>
                  </a>
                  <a href=' javascript:void(0)'>
                    <g
                      class='area'
                      id='east'
                      data-toggle='tooltip'
                      data-placement='left'
                      title='東區'
                    >
                      {/* <path d="M433.7,278.2h-1l-10.6-1.6L404.5,266l-3.6,0.9l-2.3,5.7l-4.7,4.3h-6.2l-7.9-3l-14.3-3.6            l-6.2-2.9l-2.4-2l-5.6-4.5h-4.7l-4.5,2.2l-3.8,0.6l-3.5-2.4l-4.2-2.5l-4.7-1l-1.3-3.6l0.6-5.2l-3.4-1l4.1-10l13.3-13.5l3.6-5.5            l-0.6-4.2l1.3-4.5l2.2-6.2l0.5-1.4l3.7-1.5l3.1,0.6l3.2-1.2l2.1-3.6l-2.9-11.8l5.1-3.7l2.9-0.9l5.4-1.5l4.7-1.7l3.6-3.1l4.8-3.3            l6.3-3l3.7-2.7l-0.4-1.9l-1-3l-0.2-4l1.9-4.7l4.5-3.8l3.6-2.2l12.4-5l12.8-7.7l5.9-1.8l4.8-3.4l2.9-4.8l3.1-3.9l3.5-1.9l3.3-1.1            l4.4-2.8l1.5-3.6l-2.4-3.4l1.3-2.8l10.7-2.2l3.5-2.4l8-4.2l5.6-1.2l3.1,1.8l0.8,1l-11.4,5.7l-5.2,4.5l-17.8,21.7l-2.8,4.6l-2.2,6.5            l-1.5,7.3l-0.5,7.2l0.3,7l3.1,14.7l-0.2,3.8l-1.4,3.7l0.2,7.7l3.3,6l6.2,3.8l7.2,1.3v1.7l-3-0.3l-2.9,0.3l-2.5,0.8l-1.8,1.3            l2.6,4.8l1.2,6.2l-0.8,5.3l-5.7,3.2l-0.4,2.4l0.7,2.9l1.6,2.6l0.6,2.7l-2.4,2.3l-5.9,3.4l-6.7,7.6l-0.3,3l0.5,6.7l-1.1,2.5            l-1.2,2.2l-0.8,3l-0.5,6.1l-0.6,1.5l-1,1.2l-0.5,1.3L433.7,278.2z"></path>
                                    <path d="M433.7,278.1l0.6,0.8l1.5,2.8l0.2,1l-1.3,2.3l-5.5,5.4l-5.9,8.2l-4.5,3.5l-1.3,1.9l0.7,2            l-0.9,1.4l-6.3,4.9l-2.4,2.3l-2.7,5.7l-2.8,11.6l-7,10.4l-1.4,4.2l0.2,4.5l1.7,4.9l1.4,2.2l1.2,1l0.8,1.3l0.1,3l-1,3.4l-3.5,5.5            l-0.7,3.3l-0.4,6.1l-3,15.5l-6.1,16.2l-7.6,38.1l-4.6,9.3l-10.5,61l-3.3-1l-10.3,4.9l-3.7,5.1l1.6,6.6l0.6,6.6l-3.4,6.6l-3.2,4.9            l-2.6,6.3l-2.3,8l-3.5,7.3l-4.6,12.6l-2.9,5.8l0.1,6.4l-0.9,5.9l-6.2,3.5l-7.8-1l-11.2-9.2l-8.8-15.2l-5.4-1.4l-6-0.9l-4.8-4.6            l-5.8-2.8l-7.4-2.7l-4.8-7.7l-1.1-7l-0.3-2.4l-2.7-7.2l-6-4.9l-5.3-3.4l-1-3.8l1.3-3l5.3-2.3l2.9-4.8l-1.8-5.5l5.7-3.3l2.9-2.7            l-1.6-5.9l1.4-2.6l1.4-3.8l4.9-3.7l7-1.5l7-0.3l5-4.5l1.2-8.1l3.8-4.9l7.2-2.7l4.3-2.9l1.5-4.9l3-12l1.1-8l-0.9-6.8l-1.1-5.1            l-3-3.9l-2-3.8l5.4-8.9l0.2-3.5l2.4-6.7l3.7-8.1l2.9-8.4l1.5-9.4l0.6-7.2l-1.7-4.3l-1.9-3.1l2.2-7.2l4.9-10.2l7.6-9.9l0.3-3.7            l-1.4-4.3l-4.9-3.2l-2.8-2.9l-0.2-9.4l3.5-2.8l6.3-2.1l4.9-2.3l-0.2-3.5l-1.3-5.9l2.7-1.9l1.1-2l3.2-1.6l2.9-3.6l1.2-4.9l2.9-4.8            l7.1-4.5l2.3-5.9l0.4-4l4.5-4.7l2.4,2l6.2,2.9l14.3,3.6l7.9,3h6.2l4.7-4.3l2.3-5.7l3.6-0.9l17.6,10.6l10.6,1.6L433.7,278.1z"></path>
                                    <path d="M211.8,847l-4.3,0.3l-9.7-4.5l-4.4-4.7l-3-5.6l-0.6-5.8l0.1-5.4l-2.9-4.2l-3.2-1.6l-2.6-3.7            l0.5-4.3l2-3.7l5-3l2.4-3.6l-4.4-5.3l-2.5-4.8v-5.1l-1-6.8l-1.9-5.8l-1.1-6.2l0.8-14l2.9-7.1l3.5-6.3l2.3-6.3l5.1-4.3l7.2-1.5            l4.6-2.6l9.3-3.9l1.9-4.8l0.1-4.9l2.7-13.1l-5.2-3.4l-5.1-1.2l-0.7-4.7l-3.3-6.3l3.7-0.5l-1.1-4.7l-5.9-6.1l-2.9-4.4l-1.2-7.7            l2.2-9.3l8.1-6.8l4.1-5.6l0.1-10.7l2.9-12.6l-2-9.4l0.8-6.6l7-3.8l2.6-4.7l-2.2-5.7l0.9-5.4l7.4-4.9l3.8-3.7l6.1-3.9l14.8-3.6            l1.1,7l4.8,7.7l7.4,2.7l5.8,2.8l4.8,4.6l6,0.9l5.4,1.4l8.8,15.2l11.1,9.2l7.8,1l6.2-3.5l0.9-5.9l-0.1-6.4l2.9-5.8l4.6-12.6l3.5-7.3            l2.3-8l2.6-6.3l3.2-4.9l3.4-6.6l-0.6-6.6l-1.6-6.6l3.7-5.1l10.3-4.9l3.3,1l-4.4,25.1l-2.1,4.7l-6.8,8.9l-2.5,4.7l-2,5.8l-1.4,10.8            l0.2,9.7l-1,9.2l-4.7,9.4l-2,2l-4.5,3.3l-2.1,2.1l-1,2.2l-1.6,5.5l-4.6,8l-2.8,12.5l-2,5.6l-9.8,14.1l-1.2,2.6l-13.2,11.2l-3.1,3.6            l-0.4,2.6l0.6,5.9l-0.2,2.7l-1.1,3l-2.1,3.3l-4.5,5.8l-4.5,4.3l-15.3,10.2L252.6,732l-2.6,1.3l-2,2.6l-4.9,12.8l-2.5,4.8L233,763            l-3.1,5.7l-1.8,11.7l-4.6,16l-9,15.9l-1.3,5.4l-1.6,15.3L211.8,847z"></path> */}
                    </g>
                  </a>
                </svg>
              </div>
              {_.map(options.store_groups, (item) => {
                if (item.name == '北北區') {
                  return (
                    <div class='col-lg-9 ' id='north_stores'>
                      <div class='p-4 px-md-5 bg-primary d-none d-lg-block'>
                        <div class='row align-items-center'>
                          <div class='col-lg-3'>
                            <h6 class='h5 text-white mb-0'>北區</h6>
                          </div>
                        </div>
                      </div>
                      <hr class='border-top border-primary m-0' />
                      {_.map(
                        storeInfo.filter(
                          (item) =>
                            item.store_group_name == '北北區' ||
                            item.store_group_name == '北南區'
                        ),
                        (item) => (
                          <Popover
                            mouseEnterDelay='0.5'
                            placement='left'
                            id='item.id'
                            content={content}
                            title='服務人員資訊'
                          >
                            <div
                              onMouseEnter={() => {
                                this.loadCIBC(item.id);
                              }}
                            >
                              <div class='p-4 px-md-5 bg-white d-block text-decoration-none'>
                                <div class='row align-items-center'>
                                  <div class='col-lg-3'>
                                    <h6 class='h5 text-navy mb-0'>
                                      {item.name}
                                    </h6>
                                  </div>
                                  <div class='col-lg'>
                                    <h6 class='h5 text-navy mb-0'>
                                      {item.cibc_address}
                                      <a
                                        class='gMap-link'
                                        role='button'
                                        href={`https://www.google.com.tw/maps/place/${
                                          item.cibc_address
                                        }`}
                                        target='_blank'
                                      >
                                        <img
                                          class='ml-3'
                                          src={`${
                                            VC_CONFIG.INDEX_URL
                                          }/wp-content/themes/cec/assets/img/icon/google_map.svg`}
                                          alt=''
                                        />
                                      </a>
                                    </h6>
                                  </div>
                                </div>
                              </div>
                              <hr class='border-top border-primary m-0' />
                            </div>
                          </Popover>
                        )
                      )}
                    </div>
                  );
                } else if (item.name == '中區') {
                  return (
                    <div
                      class='col-lg-9 '
                      style={{ display: 'none' }}
                      id='west_stores'
                    >
                      <div class='p-4 px-md-5 bg-primary d-none d-lg-block'>
                        <div class='row align-items-center'>
                          <div class='col-lg-3'>
                            <h6 class='h5 text-white mb-0'>中區</h6>
                          </div>
                        </div>
                      </div>
                      <hr class='border-top border-primary m-0' />
                      {_.map(
                        storeInfo.filter(
                          (item) => item.store_group_name == '中區'
                        ),
                        (item) => (
                          <Popover
                            placement='rightTop'
                            id='item.id'
                            content={content}
                            title='服務人員資訊'
                          >
                            <div
                              onMouseEnter={() => {
                                this.loadCIBC(item.id);
                              }}
                            >
                              <div class='p-4 px-md-5 bg-white d-block text-decoration-none'>
                                <div class='row align-items-center'>
                                  <div class='col-lg-3'>
                                    <h6 class='h5 text-navy mb-0'>
                                      {item.name}
                                    </h6>
                                  </div>
                                  <div class='col-lg'>
                                    <h6 class='h5 text-navy mb-0'>
                                      {item.address}
                                      <a
                                        class='gMap-link'
                                        role='button'
                                        href={`https://www.google.com.tw/maps/place/${
                                          item.address
                                        }`}
                                        target='_blank'
                                      >
                                        <img
                                          class='ml-3'
                                          src={`${
                                            VC_CONFIG.INDEX_URL
                                          }/wp-content/themes/cec/assets/img/icon/google_map.svg`}
                                          alt=''
                                        />
                                      </a>
                                    </h6>
                                  </div>
                                </div>
                              </div>
                              <hr class='border-top border-primary m-0' />
                            </div>
                          </Popover>
                        )
                      )}
                    </div>
                  );
                } else if (item.name == '南區') {
                  return (
                    <div
                      class='col-lg-9 '
                      style={{ display: 'none' }}
                      id='south_stores'
                    >
                      <div class='p-4 px-md-5 bg-primary d-none d-lg-block'>
                        <div class='row align-items-center'>
                          <div class='col-lg-3'>
                            <h6 class='h5 text-white mb-0'>南區</h6>
                          </div>
                        </div>
                      </div>
                      <hr class='border-top border-primary m-0' />
                      {_.map(
                        storeInfo.filter(
                          (item) => item.store_group_name == '南區'
                        ),
                        (item) => (
                          <Popover
                            placement='rightTop'
                            id='item.id'
                            content={content}
                            title='服務人員資訊'
                          >
                            <div
                              onMouseEnter={() => {
                                this.loadCIBC(item.id);
                              }}
                            >
                              <div class='p-4 px-md-5 bg-white d-block text-decoration-none'>
                                <div class='row align-items-center'>
                                  <div class='col-lg-3'>
                                    <h6 class='h5 text-navy mb-0'>
                                      {item.name}
                                    </h6>
                                  </div>
                                  <div class='col-lg'>
                                    <h6 class='h5 text-navy mb-0'>
                                      {item.address}
                                      <a
                                        class='gMap-link'
                                        role='button'
                                        href={`https://www.google.com.tw/maps/place/${
                                          item.address
                                        }`}
                                        target='_blank'
                                      >
                                        <img
                                          class='ml-3'
                                          src={`${
                                            VC_CONFIG.INDEX_URL
                                          }/wp-content/themes/cec/assets/img/icon/google_map.svg`}
                                          alt=''
                                        />
                                      </a>
                                    </h6>
                                  </div>
                                </div>
                              </div>
                              <hr class='border-top border-primary m-0' />
                            </div>
                          </Popover>
                        )
                      )}
                    </div>
                  );
                } else {
                  return (
                    <div
                      class='col-lg-9 '
                      style={{ display: 'none' }}
                      id='east_stores'
                    >
                      <div class='p-4 px-md-5 bg-primary d-none d-lg-block'>
                        <div class='row align-items-center'>
                          <div class='col-lg-3'>
                            <h6 class='h5 text-white mb-0'>東區</h6>
                          </div>
                        </div>
                      </div>
                      <hr class='border-top border-primary m-0' />
                      {_.map(
                        storeInfo.filter(
                          (item) => item.store_group_name == '東區'
                        ),
                        (item) => (
                          <Popover
                            placement='rightTop'
                            id='item.id'
                            content={content}
                            title='服務人員資訊'
                          >
                            <div
                              onMouseEnter={() => {
                                this.loadCIBC(item.id);
                              }}
                            >
                              <div class='p-4 px-md-5 bg-white d-block text-decoration-none'>
                                <div class='row align-items-center'>
                                  <div class='col-lg-3'>
                                    <h6 class='h5 text-navy mb-0'>
                                      {item.name}
                                    </h6>
                                  </div>
                                  <div class='col-lg'>
                                    <h6 class='h5 text-navy mb-0'>
                                      {item.address}
                                      <a
                                        class='gMap-link'
                                        role='button'
                                        href={`https://www.google.com.tw/maps/place/${
                                          item.address
                                        }`}
                                        target='_blank'
                                      >
                                        <img
                                          class='ml-3'
                                          src={`${
                                            VC_CONFIG.INDEX_URL
                                          }/wp-content/themes/cec/assets/img/icon/google_map.svg`}
                                          alt=''
                                        />
                                      </a>
                                    </h6>
                                  </div>
                                </div>
                              </div>
                              <hr class='border-top border-primary m-0' />
                            </div>
                          </Popover>
                        )
                      )}
                    </div>
                  );
                }
              })}
            </div>
          </section>
        </div>
      </main>
    );
  }
}

// 編輯器
export class CIBCServicePointEditor extends Component {
  render() {
    return <div className='vu-blocks-editor'>編輯器</div>;
  }
}

window.onload = function() {
  var tab_li = document.getElementsByTagName('g');
  for (var i = 0; i < tab_li.length; i++) {
    tab_li[i].index = i;
    tab_li[i].onclick = function() {
      //var content = document.getElementById(this.id + "_stores");
      var content_remove;
      for (var j = 0; j < tab_li.length; j++) {
        content_remove = document.getElementById(tab_li[j].id + '_stores');
        tab_li[j].classList.remove('active');
        $("[id$='_stores']").attr('style', 'display:none');
      }
      this.setAttribute('class', ' area active');
      $('#' + this.id + '_stores').show();
    };
  }
};



// WEBPACK FOOTER //
// ./src/blocks/cibc/cibc-servicepoint.js